export const COLOR_INVENTORY = [
  {
    "id": "hex-000000",
    "label": "Black",
    "defaultValue": "#000000",
    "locations": [
      "src/components/formFields/radioField.js",
      "src/index.css",
      "src/layouts/dashboard/nav/index.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-0000ff",
    "label": "#0000FF in AppWebsiteVisits.js",
    "defaultValue": "#0000FF",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-ffffff",
    "label": "White",
    "defaultValue": "#FFFFFF",
    "locations": [
      "src/assets/pin-red.svg",
      "src/components/color-utils/ColorMultiPicker.js",
      "src/components/color-utils/ColorSinglePicker.js",
      "src/components/form/bookingForm.js",
      "src/components/menu/notification-menu.js",
      "src/index.css",
      "src/pages/UsersPage.js",
      "src/sections/@dashboard/app/AppNewsUpdate.js",
      "src/sections/@dashboard/app/AppOrderTimeline.js",
      "src/sections/@dashboard/app/AppPopularTimes.js",
      "src/sections/@dashboard/app/AppWebsiteVisits.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-00ab55",
    "label": "#00AB55 in ProductFilterSidebar.js",
    "defaultValue": "#00AB55",
    "locations": [
      "src/sections/@dashboard/products/ProductFilterSidebar.js"
    ]
  },
  {
    "id": "hex-00ced1",
    "label": "#00CED1 in AppWebsiteVisits.js",
    "defaultValue": "#00CED1",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-00ff00",
    "label": "#00FF00 in AppWebsiteVisits.js",
    "defaultValue": "#00FF00",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-04297a",
    "label": "#04297A in palette.js",
    "defaultValue": "#04297A",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-061b64",
    "label": "#061B64 in palette.js",
    "defaultValue": "#061B64",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-08660d",
    "label": "#08660D in palette.js",
    "defaultValue": "#08660D",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-091a7a",
    "label": "#091A7A in palette.js",
    "defaultValue": "#091A7A",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-0c53b7",
    "label": "#0C53B7 in palette.js",
    "defaultValue": "#0C53B7",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-103996",
    "label": "#103996 in palette.js",
    "defaultValue": "#103996",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-111",
    "label": "#111 in bookingForm.js",
    "defaultValue": "#111",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-1565c0",
    "label": "#1565C0 in UsersPage.js",
    "defaultValue": "#1565C0",
    "locations": [
      "src/pages/UsersPage.js"
    ]
  },
  {
    "id": "hex-161c24",
    "label": "#161C24 in palette.js",
    "defaultValue": "#161C24",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-1890ff",
    "label": "Info blue",
    "defaultValue": "#1890FF",
    "locations": [
      "src/index.css",
      "src/sections/@dashboard/products/ProductFilterSidebar.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-1939b7",
    "label": "#1939B7 in palette.js",
    "defaultValue": "#1939B7",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-1976d2",
    "label": "#1976D2 in UsersPage.css",
    "defaultValue": "#1976D2",
    "locations": [
      "src/pages/UsersPage.css"
    ]
  },
  {
    "id": "hex-1a50a3",
    "label": "Sidebar background",
    "defaultValue": "#1A50A3",
    "locations": [
      "src/components/nav-section/NavSection.js",
      "src/components/nav-section/styles.js",
      "src/layouts/dashboard/nav/index.js"
    ]
  },
  {
    "id": "hex-1b66b2",
    "label": "#1B66B2 in ItemListEditorModal.js",
    "defaultValue": "#1B66B2",
    "locations": [
      "src/components/itemListEditor/ItemListEditorModal.js"
    ]
  },
  {
    "id": "hex-2064d1",
    "label": "Pinned sidebar blue",
    "defaultValue": "#2064D1",
    "locations": [
      "src/layouts/dashboard/nav/index.js"
    ]
  },
  {
    "id": "hex-2065d1",
    "label": "Primary brand blue",
    "defaultValue": "#2065D1",
    "locations": [
      "src/index.css",
      "src/pages/BookingsPage.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-212b36",
    "label": "#212B36 in palette.js",
    "defaultValue": "#212B36",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-229a16",
    "label": "#229A16 in palette.js",
    "defaultValue": "#229A16",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-3366ff",
    "label": "Secondary blue",
    "defaultValue": "#3366FF",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-3ddf84",
    "label": "#3DDF84 in MetricCard.js",
    "defaultValue": "#3DDF84",
    "locations": [
      "src/components/MetricCard.js"
    ]
  },
  {
    "id": "hex-454f5b",
    "label": "#454F5B in palette.js",
    "defaultValue": "#454F5B",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-54d62c",
    "label": "Success green",
    "defaultValue": "#54D62C",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-637381",
    "label": "#637381 in palette.js",
    "defaultValue": "#637381",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-666",
    "label": "#666 in ItemListEditorModal.js",
    "defaultValue": "#666",
    "locations": [
      "src/components/itemListEditor/ItemListEditorModal.js"
    ]
  },
  {
    "id": "hex-74caff",
    "label": "#74CAFF in palette.js",
    "defaultValue": "#74CAFF",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-76b0f1",
    "label": "#76B0F1 in palette.js",
    "defaultValue": "#76B0F1",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-7a0c2e",
    "label": "#7A0C2E in palette.js",
    "defaultValue": "#7A0C2E",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-7a4f01",
    "label": "#7A4F01 in palette.js",
    "defaultValue": "#7A4F01",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-7d4",
    "label": "#7D4 in palette.js",
    "defaultValue": "#7D4",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-7fffd4",
    "label": "#7FFFD4 in AppWebsiteVisits.js",
    "defaultValue": "#7FFFD4",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-84a9ff",
    "label": "#84A9FF in palette.js",
    "defaultValue": "#84A9FF",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-888",
    "label": "#888 in bookingForm.js",
    "defaultValue": "#888",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-8a2be2",
    "label": "#8A2BE2 in AppWebsiteVisits.js",
    "defaultValue": "#8A2BE2",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-919eab",
    "label": "#919EAB in palette.js",
    "defaultValue": "#919EAB",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-94d82d",
    "label": "#94D82D in ProductFilterSidebar.js",
    "defaultValue": "#94D82D",
    "locations": [
      "src/sections/@dashboard/products/ProductFilterSidebar.js"
    ]
  },
  {
    "id": "hex-9e9e9e",
    "label": "#9E9E9E in locationField.js",
    "defaultValue": "#9E9E9E",
    "locations": [
      "src/components/maps/locationField.js"
    ]
  },
  {
    "id": "hex-aaf27f",
    "label": "#AAF27F in palette.js",
    "defaultValue": "#AAF27F",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-abd",
    "label": "#ABD in palette.js",
    "defaultValue": "#ABD",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-adff2f",
    "label": "#ADFF2F in AppWebsiteVisits.js",
    "defaultValue": "#ADFF2F",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-aeb",
    "label": "#AEB in palette.js",
    "defaultValue": "#AEB",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-b72136",
    "label": "#B72136 in palette.js",
    "defaultValue": "#B72136",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-b78103",
    "label": "#B78103 in palette.js",
    "defaultValue": "#B78103",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-bb7",
    "label": "#BB7 in palette.js",
    "defaultValue": "#BB7",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-bb76",
    "label": "#BB76 in palette.js",
    "defaultValue": "#BB76",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-bbb",
    "label": "#BBB in bookingForm.js",
    "defaultValue": "#BBB",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-c4c4c4",
    "label": "#C4C4C4 in bookingForm.js",
    "defaultValue": "#C4C4C4",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-c4cdd5",
    "label": "#C4CDD5 in palette.js",
    "defaultValue": "#C4CDD5",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-cccccc",
    "label": "Light Gray #CCC",
    "defaultValue": "#CCCCCC",
    "locations": [
      "src/components/maps/locationField.js",
      "src/pages/BookingsDetailsPage.js"
    ]
  },
  {
    "id": "hex-d0f2ff",
    "label": "#D0F2FF in palette.js",
    "defaultValue": "#D0F2FF",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-d1e9fc",
    "label": "#D1E9FC in palette.js",
    "defaultValue": "#D1E9FC",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-d20000",
    "label": "#D20000 in bookingForm.js",
    "defaultValue": "#D20000",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-d32f2f",
    "label": "#D32F2F in UsersPage.css",
    "defaultValue": "#D32F2F",
    "locations": [
      "src/pages/UsersPage.css"
    ]
  },
  {
    "id": "hex-d6e4ff",
    "label": "#D6E4FF in palette.js",
    "defaultValue": "#D6E4FF",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-dae",
    "label": "#DAE in palette.js",
    "defaultValue": "#DAE",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-dcd",
    "label": "#DCD in palette.js",
    "defaultValue": "#DCD",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-dfe3e8",
    "label": "#DFE3E8 in palette.js",
    "defaultValue": "#DFE3E8",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-e0e0e0",
    "label": "#E0E0E0 in locationField.js",
    "defaultValue": "#E0E0E0",
    "locations": [
      "src/components/maps/locationField.js"
    ]
  },
  {
    "id": "hex-e0e4e8",
    "label": "#E0E4E8 in locationField.js",
    "defaultValue": "#E0E4E8",
    "locations": [
      "src/components/maps/locationField.js"
    ]
  },
  {
    "id": "hex-e9fcd4",
    "label": "#E9FCD4 in palette.js",
    "defaultValue": "#E9FCD4",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-eaeaeb",
    "label": "#EAEAEB in index.css",
    "defaultValue": "#EAEAEB",
    "locations": [
      "src/index.css"
    ]
  },
  {
    "id": "hex-f02",
    "label": "#F02 in palette.js",
    "defaultValue": "#F02",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-f0f7ff",
    "label": "#F0F7FF in ItemListEditorModal.js",
    "defaultValue": "#F0F7FF",
    "locations": [
      "src/components/itemListEditor/ItemListEditorModal.js"
    ]
  },
  {
    "id": "hex-f26",
    "label": "#F26 in palette.js",
    "defaultValue": "#F26",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-f4f6f8",
    "label": "#F4F6F8 in palette.js",
    "defaultValue": "#F4F6F8",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-f5f5f5",
    "label": "#F5F5F5 in bookingForm.js",
    "defaultValue": "#F5F5F5",
    "locations": [
      "src/components/form/bookingForm.js"
    ]
  },
  {
    "id": "hex-f9fafb",
    "label": "#F9FAFB in palette.js",
    "defaultValue": "#F9FAFB",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-fafafa",
    "label": "#FAFAFA in ItemListEditorModal.js",
    "defaultValue": "#FAFAFA",
    "locations": [
      "src/components/itemListEditor/ItemListEditorModal.js"
    ]
  },
  {
    "id": "hex-ff0000",
    "label": "#FF0000 in AppWebsiteVisits.js",
    "defaultValue": "#FF0000",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-ff3b30",
    "label": "#FF3B30 in pin-red.svg",
    "defaultValue": "#FF3B30",
    "locations": [
      "src/assets/pin-red.svg"
    ]
  },
  {
    "id": "hex-ff4842",
    "label": "Error red",
    "defaultValue": "#FF4842",
    "locations": [
      "src/sections/@dashboard/products/ProductFilterSidebar.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-ff4e4e",
    "label": "#FF4E4E in MetricCard.js",
    "defaultValue": "#FF4E4E",
    "locations": [
      "src/components/MetricCard.js"
    ]
  },
  {
    "id": "hex-ffa48d",
    "label": "#FFA48D in palette.js",
    "defaultValue": "#FFA48D",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-ffa500",
    "label": "#FFA500 in AppWebsiteVisits.js",
    "defaultValue": "#FFA500",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-ffc0cb",
    "label": "#FFC0CB in AppWebsiteVisits.js",
    "defaultValue": "#FFC0CB",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js",
      "src/sections/@dashboard/products/ProductFilterSidebar.js"
    ]
  },
  {
    "id": "hex-ffc107",
    "label": "Warning amber",
    "defaultValue": "#FFC107",
    "locations": [
      "src/sections/@dashboard/products/ProductFilterSidebar.js",
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-ffd700",
    "label": "#FFD700 in AppWebsiteVisits.js",
    "defaultValue": "#FFD700",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  },
  {
    "id": "hex-ffe16a",
    "label": "#FFE16A in palette.js",
    "defaultValue": "#FFE16A",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-ffe7d9",
    "label": "#FFE7D9 in palette.js",
    "defaultValue": "#FFE7D9",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-fff7cd",
    "label": "#FFF7CD in palette.js",
    "defaultValue": "#FFF7CD",
    "locations": [
      "src/theme/palette.js"
    ]
  },
  {
    "id": "hex-ffff00",
    "label": "#FFFF00 in AppWebsiteVisits.js",
    "defaultValue": "#FFFF00",
    "locations": [
      "src/sections/@dashboard/app/AppWebsiteVisits.js"
    ]
  }
];
